<template>
  <div id="app" :class="{ 'lang-ja': $i18n.locale === 'ja' }" @click="handleClick">
    <head-view ref="headViewRef" v-if="!isMbRoute() && !isStandalonePage()"/>
    <mobile-head-view v-if="isMbRoute() && !isStandalonePage()"/>
    
    <main class="main-content">
      <router-view />
    </main>

    <foot-view v-if="!isMbRoute() && !isStandalonePage()"/>
    <mobile-foot-view v-if="isMbRoute() && !isStandalonePage()"/>
  </div>
</template>
<script>
import footView from "@/components/footView/footView.vue"
import headView from "@/components/headView/headView.vue"
import MobileHeadView from "@/components/headView/mobileHeadView";
import MobileFootView from "@/components/footView/mobileFootView";
export default {
  data() {
    return {

    };
  },
  mounted() {
    // 调用方法，打印匹配结果
    console.log("是否包含 'mb_':", this.isMbRoute());
    console.log("是否为独立页面:", this.isStandalonePage());
  },
  components: {MobileFootView, MobileHeadView, footView, headView },
  watch: {
    '$i18n.locale': function() {
      if (this.$route.meta.title) {
        document.title = this.$t(this.$route.meta.title);
      }
    }
  },
  methods:{
    isMbRoute() {
      // 获取当前路由路径
      const currentRoute = this.$route.path;
      console.log("当前路由路径:", currentRoute);

      // 正则匹配是否包含 "mb_"
      const regex = /mb_/;
      return regex.test(currentRoute);
    },
    isStandalonePage() {
      // Check if current route is a standalone page (like CoQ10)
      const currentRoute = this.$route.path;
      const standaloneRoutes = ['/coq10'];
      return standaloneRoutes.includes(currentRoute);
    },
    handleClick(route) {
      // Only handle click if not on standalone page and headViewRef exists
      if (!this.isStandalonePage() && this.$refs.headViewRef) {
        const headViewElement = this.$refs.headViewRef.$el;
        if(!headViewElement.contains(event.target)){
          this.$refs.headViewRef.updateShow();
        }
      }
    }
  }
};
</script>
<style lang="less">
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.main-content {
  flex: 1;
}
#app.lang-ja,
#app.lang-ja * {
  font-family: "Meiryo", "メイリオ", sans-serif;
}
</style>
